var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ReportHeaderRow',{attrs:{"name":_vm.reportName}}),_c('v-container',{staticClass:"justify-center",attrs:{"fluid":"","fill-height":""}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }